<div class="relative">
  <button
    class="p-2 rounded bg-gray-100 dark:bg-dark-hover text-slate-600 hover:bg-gray-200 dark:hover:bg-dark-border hover:text-gray-500 dark:hover:text-dark-muted
disabled:bg-slate-50 disabled:text-slate-300 disabled:cursor-not-allowed"
    [title]="'table.columns.title' | translate"
    (click)="toggle()"
  >
    <lucide-icon size="16" [name]="Columns3"></lucide-icon>
  </button>

  @if (selectorOpen) {
    <div class="absolute flex flex-col left-9 bottom-0 overflow-hidden min-w-72 min-h-32 max-h-72 h-auto bg-white dark:bg-dark-card border border-gray-200 dark:border-dark-border rounded-md shadow-sm">
      <div class="flex bg-gray-100 dark:bg-dark-hover border-b border-gray-200 dark:border-dark-border text-gray-400 justify-between items-center">
        <div class="text-sm p-2">{{ 'table.columns.title' | translate }}</div>
        <div>
          <a href="#"
             class="border-l border-l-gray-200 dark:border-l-dark-border flex items-center justify-center p-2 hover:bg-gray-50 dark:hover:bg-dark-hover hover:text-gray-400"
             (click)="$event.preventDefault(); toggle()">
            <lucide-angular size="16" [name]="X"></lucide-angular>
          </a>
        </div>
      </div>
      <div class="p-2 overflow-y-auto flex-grow">
        <ul>
          @for (column of availableColumns; track column.key) {
            <li
              class="text-sm text-gray-600 dark:text-gray-400 flex cursor-pointer items-center border-b border-b-gray-100 dark:border-b-dark-border py-1 gap-2"
              (click)="toggleColumn(column)"
            >
              <input type="checkbox" class="ec-input" [checked]="selectedColumns.indexOf(column) > -1"> {{ column.title | translate }}
            </li>
          }
        </ul>
      </div>
      <div class="px-2 py-1 border-b border-gray-200 dark:border-dark-border text-xs flex items-center justify-end">
        <a
          class="bg-slate-100 dark:bg-dark-hover rounded-lg text-secondary dark:text-dark-muted px-3 py-1 text-xs hover:bg-theme-primary hover:text-white transition-all ease-in-out"
          href="#"
          (click)="$event.preventDefault(); reset()"
        >
          {{ 'common.reset' | translate }}
        </a>
      </div>
    </div>
  }
</div>
